export default defineNuxtPlugin(() => {
  const handleBlockLinkClick = (
    event: MouseEvent,
    el: HTMLAnchorElement | null,
  ) => {
    if (!el) return // Ensure `el` is not null before proceeding

    const target = event.target

    // Type guard: Ensure `target` is an Element before accessing `tagName`
    if (target instanceof Element && target.tagName.toLowerCase() === 'a') {
      return
    }

    // Check if text is selected before triggering a programmatic click
    if (typeof window !== 'undefined' && !window.getSelection()?.toString()) {
      el.click()
    }
  }

  return {
    provide: {
      handleBlockLinkClick,
    },
  }
})
